'use strict';
exports.test = function () {
  // Don't get fooled by e.g. browserify environments.
  return (typeof process !== 'undefined') && !process.browser;
};

exports.install = function (func) {
  return function () {
    process.nextTick(func);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/immediate/lib/nextTick.js
// module id = 608
// module chunks = 0